import { useLanguage } from '@/contexts/language/LanguageContext';
import type { SiteLanguage } from '@/contexts/language/LanguageContext';
import { cn } from '@/lib/utils';

const LANGUAGES: { code: SiteLanguage; label: string; name: string }[] = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'sk', label: 'SK', name: 'Slovenčina' },
];

// Quiet "EN | SK" toggle on desktop; "pill" = big segmented toggle with 40px tap targets for phones.
// Hidden on pages that only exist in English.
const LanguageSelector = ({ className, variant = 'text' }: { className?: string; variant?: 'text' | 'pill' }) => {
  const { language, setLanguage, isBilingualPage } = useLanguage();

  if (!isBilingualPage) return null;

  if (variant === 'pill') {
    return (
      <div className={cn('inline-flex items-center rounded-full border border-[#2A1E47]/15 bg-white p-0.5 text-sm font-semibold', className)}>
        {LANGUAGES.map(({ code, label, name }) => (
          <button
            key={code}
            type="button"
            onClick={() => setLanguage(code)}
            aria-label={name}
            aria-current={language === code ? 'true' : undefined}
            className={cn(
              'min-w-[2.75rem] h-10 px-3 rounded-full transition-colors',
              language === code ? 'bg-[#2A1E47] text-white' : 'text-[#2A1E47]/60 active:bg-[#2A1E47]/10'
            )}
          >
            {label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-1 text-sm font-medium', className)}>
      {LANGUAGES.map(({ code, label, name }, i) => (
        <span key={code} className="flex items-center gap-1">
          {i > 0 && <span className="text-[#2A1E47]/25" aria-hidden>|</span>}
          <button
            type="button"
            onClick={() => setLanguage(code)}
            aria-label={name}
            aria-current={language === code ? 'true' : undefined}
            className={cn(
              'px-1 py-0.5 rounded transition-colors',
              language === code ? 'text-[#2A1E47]' : 'text-[#2A1E47]/45 hover:text-[#2A1E47]'
            )}
          >
            {label}
          </button>
        </span>
      ))}
    </div>
  );
};

export default LanguageSelector;
